import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import {
  getIsHotelOnly,
  getIsWhitelabel,
  getIsMobile,
} from 'src/store/view/selectors';

import { getIsManualPackage } from '../../../../store/selectors/package';
import { getHotelRoulette } from '../../../../store/selectors/hotel';

import { PackageRoute } from './Package';

const mapStateToProps = (state) => ({
  isManualPackage: getIsManualPackage(state),
  isRoulette: getHotelRoulette(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  isWhitelabel: getIsWhitelabel(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(PackageRoute);
